import React from 'react';
import PropTypes from 'prop-types';
import styled  from 'styled-components';
import { HideDomElements, SetHtmlBodyHeight } from 'components/misc/globalStyles';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import DefaultCard from 'newJs/containers/Card';
import HeaderButtons from 'containers/Attachments/misc/GroupedActions';
import ListAsGrid from './List/Grid';
import {useMessageStore} from 'state/index';
import {useGlobalProps} from 'providers/global-props';

const Card = styled(DefaultCard)`
    .attach-panel {
        &__grid-container {
            >div:first-child {
                margin: 0 auto;
                position: relative;
            }
            /* NOTE: Padding on small screens is added due to iPhone bottom toolbar */
            ${props => props.isSmallScreen ? `padding-bottom: calc(1.4 * 64px)` : ''}
        }
    }
`;

const AttachmentsAsGrid = () => {
    const { currentViewMode, isPreviewMode, historyBack } = useAttachsState();
    const { escKeyHandler } = useAttachsParams();
    const emlData = useMessageStore((state) => state.emlData);
    const { i18n: { message } } = useGlobalProps();

    React.useEffect(() => {
        const escFunction = escKeyHandler(() => historyBack());

        if (currentViewMode && !isPreviewMode()) {
            document.addEventListener('keydown', escFunction, false);
        }
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [currentViewMode, escKeyHandler, historyBack, isPreviewMode]);

    return (
        <Card onClose={historyBack} skin='light'>
            <Card.Header
                buttons={
                    <HeaderButtons showDownloadAll as="button" showGridBtn={false} />
                }
            >
                <Card.Title title={emlData.subject}>{emlData.subject}</Card.Title>
            </Card.Header>
            <Card.Body>
                <SetHtmlBodyHeight />
                <HideDomElements />
                <ListAsGrid />
            </Card.Body>
        </Card>
    );
};

AttachmentsAsGrid.propTypes = { isSmallScreen: PropTypes.bool };

export default AttachmentsAsGrid;
